import React from 'react'
import './reportsuploader.css'

function EmptyReport({onTargetClick}) {
    return (
        <div className='empty-report-container' onClick={onTargetClick}>

            <img className='upload-icon' src={require('../../assets/InterBranch/PNGIcons/upload1.png')} alt="" />
            <span>Click here or Drag files to upload</span>
            <span>(Supported Format - PDF, PNG, JPEG, JPG, DOC, DOCX, DCM, ZIP. </span>
            <span>Maximum size per file is 5MB</span>
            <span>Maximum number of files is 3)</span>
            
        </div>
    )
}

export default EmptyReport
